/* eslint-disable max-len */
/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable no-unused-vars */
import React, { useState, useEffect } from 'react';
import DatePicker from 'react-datepicker';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes } from '@fortawesome/free-solid-svg-icons';
import { useForm } from 'react-hook-form';
import moment from 'moment/moment';
import Swal from 'sweetalert2';
import { validateAge } from '../Validators';
import 'react-datepicker/dist/react-datepicker.css';
import './EditHprModal.scss';

const EditHprModal = ({
  show, toggle, onSubmit, values,
}) => {
  const dateParts = values && values?.age !== null
    ? values?.age?.split('/')
    : new Date();
  const dateObject = values && values?.age !== null
    ? new Date(+dateParts[2], dateParts[1] - 1, +dateParts[0])
    : '';
  const [age, setage] = useState(values ? new Date(values?.age) : new Date(moment().subtract(18, 'years')));
  const [freqError, setFreqError] = useState(null);
  const [dateError, setDate] = useState(null);
  const [qtyError, setQtyError] = useState(null);
  const userRole = localStorage?.getItem('role');
  const showHideClassName = show ? 'edit-user-modal display-block' : 'edit-user-modal display-none';
  const {
    register, handleSubmit, setValue, formState: { errors },
  } = useForm();

  useEffect(() => {
    if (values) {
      setValue('hprOrDfName', values.hprOrDfName);
      setValue('mobileNumber', values.mobileNumber ? values.mobileNumber.replace('+91', '') : '');
      setValue('gender', values.gender);
      setValue('hprOrDf', values.hprOrDf);
      setValue('mccName', values.mccName);
      setValue('panCard', values?.panCard);
      setValue('aadhaarPancardLinkStatus', values?.aadhaarPancardLinkStatus);
      // setValue('hpcCode', values?.hpcCode);
      setValue('aadhaarNumber', values?.aadhaarNumber);
      setage(values ? new Date(values?.age) : new Date(
        moment().subtract(18, 'years'),
      ));
    }
  }, [setValue, values]);

  const submit = ({
    hprOrDfName,
    gender,
    hprOrDf,
    mccName,
    panCard,
    aadhaarPancardLinkStatus,
    aadhaarNumber,
    mobileNumber,
  }) => {
    toggle();
    const validationMessage = validateAge(age, 18, 108);
    if (validationMessage) {
      Swal.fire({
        icon: 'warning',
        toast: true,
        title: validationMessage,
      });
    } else {
      onSubmit({
        hprOrDfName,
        gender,
        age,
        hprOrDf,
        mccName,
        panCard,
        aadhaarPancardLinkStatus,
        aadhaarNumber,
        mobileNumber,
      });
    }
  };

  return (
    <div className={showHideClassName}>
      <section className="modal-main">
        <div className="row">
          <div className="col-12 d-flex end">
            <button type="button" className="modal-main__button" onClick={toggle}>
              <FontAwesomeIcon icon={faTimes} />
            </button>
          </div>
          <div className="col-12">
            <div className="form">
              <div className="row">
                <div className="col-12 col-md-6">
                  <div className="form__item">
                    <label htmlFor="frequency">
                      <div className="row middle">
                        <div className="col-12">
                          <span className="form__label">Name</span>
                        </div>
                        <div className="col-12">
                          <input
                            className="form__field"
                            type="text"
                            id="hprOrDfName"
                            name="hprOrDfName"
                            placeholder="Name"
                            {...register('hprOrDfName', { required: { value: true, message: 'Name is required' } })}
                          />
                          {errors.hprOrDfName && <div className="form__error">{errors.hprOrDfName.message}</div>}
                        </div>
                      </div>
                    </label>
                  </div>
                  <div className="form__item">
                    <label htmlFor="frequency">
                      <div className="row middle">
                        <div className="col-12">
                          <span className="form__label">Mobile Number</span>
                        </div>
                        <div className="col-12">
                          <input
                            className="form__field"
                            type="text"
                            id="mobileNumber"
                            name="mobileNumber"
                            maxLength={10}
                            disabled
                            placeholder="mobileNumber number"
                            {...register('mobileNumber', {
                              required: { value: true, message: 'mobileNumber number is required' },
                              minLength: {
                                value: 10,
                                message:
                                'mobileNumber Number must not be less than 10 digits',
                              },
                              maxLength: {
                                value: 10,
                                message:
                                'mobileNumber Number must not be greater than 10 digits',
                              },
                            })}
                            // value={mobileNumber}
                            // onChange={(e) => setmobileNumber(e.target.value)}
                          />
                          {errors.mobileNumber && <div className="form__error">{errors.mobileNumber.message}</div>}
                        </div>
                      </div>
                    </label>
                  </div>
                  <div className="form__item">
                    <label htmlFor="frequency">
                      <div className="row middle">
                        <div className="col-12">
                          <span className="form__label">MCC Name</span>
                        </div>
                        <div className="col-12">
                          <input
                            className="form__field"
                            type="text"
                            id="mccName"
                            name="mccName"
                            placeholder="mcc Name"
                            {...register('mccName', { required: { value: true, message: 'mccName is required' } })}
                          />
                          {errors.mccName && <div className="form__error">{errors.mccName.message}</div>}
                        </div>
                      </div>
                    </label>
                  </div>
                  {/* <div className="form__item">
                    <label htmlFor="frequency">
                      <div className="row middle">
                        <div className="col-12">
                          <span className="form__label">HPC Code</span>
                        </div>
                        <div className="col-12">
                          <input
                            className="form__field"
                            type="text"
                            id="hpcCode"
                            name="hpcCode"
                            placeholder="HPC Code"
                            {...register('hpcCode', { required: { value: true, message: 'HPC Code  is required' } })}
                          />
                          {errors.hpcCode && <div className="form__error">{errors.hpcCode.message}</div>}
                        </div>
                      </div>
                    </label>
                  </div> */}
                </div>
                <div className="col-12 col-md-6">
                  <div className="form__item">
                    <label htmlFor="quantity">
                      <div className="row middle">
                        <div className="col-12">
                          <span className="form__label">Gender</span>
                        </div>
                        <div className="col-12">
                          <select
                            id="gender"
                            name="gender"
                            className="form__field"
                            {...register('gender', { required: { value: true, message: 'Gender is required' } })}
                            // value={gender}
                            // onChange={(e) => setGender(e.target.value)}
                          >
                            <option value="MALE">Male</option>
                            <option value="FEMALE">Female</option>
                          </select>
                          {errors.gender && <div className="form__error">{errors.gender.message}</div>}
                        </div>
                      </div>
                    </label>
                  </div>
                  <div className="form__item">
                    <label htmlFor="quantity">
                      <div className="row middle">
                        <div className="col-12">
                          <span className="form__label">Type</span>
                        </div>
                        <div className="col-12">
                          <select
                            id="hprorDf"
                            name="hprorDf"
                            className="form__field"
                            {...register('hprOrDf', { required: { value: true, message: 'HPR Or DF is required' } })}
                            // value={gender}
                            // onChange={(e) => setGender(e.target.value)}
                          >
                            <option value="HPR">HPR</option>
                            <option value="DF">DF</option>
                          </select>
                          {errors.hprOrDf && <div className="form__error">{errors.hprOrDf.message}</div>}
                        </div>
                      </div>
                    </label>
                  </div>
                  <div className="form__item">
                    <label htmlFor="durarion">
                      <div className="row middle">
                        <div className="col-12">
                          <span className="form__label">Date of Birth</span>
                        </div>
                        <div className="col-12">
                          <DatePicker
                            selected={age}
                            onChange={(date) => setage(date)}
                            // minDate={new Date(moment().subtract(150, 'years'))}
                            // maxDate={new Date(moment().subtract(18, 'years'))}
                            dateFormat="dd/MM/yyyy"
                            className="form__field"
                          />
                          {dateError && <div className="form__error">{dateError}</div>}
                        </div>
                      </div>
                    </label>
                  </div>
                  {/* --------------------Changes made by priyanka (remove aadhar number field)----------------------- */}
                  {/* <div className="form__item">
                    <label htmlFor="frequency">
                      <div className="row middle">
                        <div className="col-12">
                          <span className="form__label">Aadhar Number</span>
                        </div>
                        <div className="col-12">
                          <input
                            className="form__field"
                            type="text"
                            id="aadhaarNumber "
                            name="aadhaarNumber "
                            maxLength={12}
                            placeholder="Aadhar Number"
                            {...register('aadhaarNumber ', {
                              required: { value: true, message: 'Aadhar is required' },
                              // minLength: {
                              //   value: 12,
                              //   message:
                              //     'Aadhar Number must not be less than 12 digits',
                              // },
                              // maxLength: {
                              //   value: 12,
                              //   message:
                              //     'Aadhar Number must not be greater than 12 digits',
                              // },
                            })}
                          />
                          {errors.aadhaarNumber  && <div className="form__error">{errors.aadhaarNumber .message}</div>}
                        </div>
                      </div>
                    </label>
                  </div> */}
                </div>
                <div className="col-12">
                  <div className="form__item">
                    <div className="row">
                      <div className="col-12 d-flex-col middle">
                        <button type="button" className="form__button" onClick={handleSubmit(submit)}>Save</button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default EditHprModal;
